import React from 'react'
import { Spacer } from '@/components/Spacer'
import type { SpacerBlock as BlockProps } from '@/payload-types'

const TIER_REM: Record<string, number> = {
  xs: 0.25,
  sm: 0.5,
  md: 1,
  lg: 2,
  xl: 4,
  '2xl': 8,
}

// Legacy `size` (raw rem) wins when set — preserves existing docs that
// specified precise values like 4 or 8. Otherwise we look up the tier.
function resolveSize(size?: number | null, tier?: string | null): number {
  if (typeof size === 'number' && size > 0) return size
  if (tier && TIER_REM[tier]) return TIER_REM[tier]
  return TIER_REM.md
}

export const SpacerBlock: React.FC<BlockProps> = ({ size, tier, orientation }) => {
  const remValue = resolveSize(size, tier)
  return <Spacer size={remValue} orientation={orientation || undefined} />
}
